var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('main-header'),_c('el-col',{attrs:{"span":4,"lg":4}},[_c('back-menu')],1),_c('el-col',{attrs:{"span":20,"lg":20}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }